module.exports = __webpack_public_path__ + "media/images/icon_category01-44972530f37607b55893034811c53fa7.png";